import { z } from 'zod'
import typeguard from './typeguard'

const allShops = {

  // Web-Shops
  101: {
    name: "Homey Love",
    icon: 'homeyloveNeu.png',
    url: 'https://www.homeylove.de/',
  },
  201: {
    name: "Angelina Minardi",
    icon: 'angelinaminardi.png',
    url: 'https://shop.angelinaminardi.de/',
  },
  202: {
    name: "liebeszuhause",
    icon: 'liebeszuhause.png',
    url: 'https://www.liebeszuhause.de/',
  },
  203: {
    name: "hellomom",
    icon: 'hellomom.png',
    url: 'https://www.hellomom.de/',
  },
  204: {
    name: "Designmöbelkaufen",
    icon: 'designmoebelkaufen.png',
    url: 'https://www.designmoebelkaufen.de/',
  },
  205: {
    name: "Mysellsy Demo",
    icon: 'sellsydemo.png',
    url: 'https://shop.mysellsy.de/',
  },

  // Marketplaces
  1001: {
    name: "Amazon",
    icon: 'amazon.png',
    url: null,
  },
  1002: {
    name: "eBay",
    icon: 'ebay.png',
    url: null,
  },

}

const readAllowedShopIds = () => {
  const raw = [
    process.env.ALLOWED_SHOP_IDS,
    process.env.REACT_APP_ALLOWED_SHOP_IDS,
    process.env.NEXT_PUBLIC_ALLOWED_SHOP_IDS,
  ].find(value => typeof value === 'string' && value.trim() !== '')

  if (!raw) return null

  const allowedIds = raw
    .split(',')
    .map(value => Number(value.trim()))
    .filter(value => Number.isInteger(value))

  return allowedIds.length > 0 ? new Set(allowedIds) : null
}

const allowedShopIds = readAllowedShopIds()

export const shops = Object.fromEntries(
  Object.entries(allShops).filter(([shopId]) => {
    if (!allowedShopIds) return true
    const parsedShopId = Number(shopId)
    return parsedShopId >= 1000 || allowedShopIds.has(parsedShopId)
  }),
) as typeof allShops

const shopSchema = z.union([
  z.literal(101),
  z.literal(201),
  z.literal(202),
  z.literal(203),
  z.literal(204),
  z.literal(205),
  z.literal(1001),
  z.literal(1002),

])
//const shopSchema = z.literal(101)
export type shopId = z.infer<typeof shopSchema>
const isKnownShopId = typeguard<shopId>(shopSchema)

export const isShopId = (value: unknown, log = true): value is shopId => {
  if (!isKnownShopId(value, log)) return false
  return !allowedShopIds || Number(value) >= 1000 || allowedShopIds.has(Number(value))
}
